<form [formGroup]="form()">
  <onyx-form-group
    [label]="label()"
    [controls]="form().controls[language()]"
    (labelClick)="nameControl.focus()"
  >
    <onyx-text-field
      [formControlName]="language()"
      [showErrors]="false"
      #nameControl
    ></onyx-text-field>

    <onyx-button variant="outlined" (click)="toggleTranslations()">
      <onyx-icon
        left
        class="icon"
        [class.active]="showTranslations()"
        name="translations-outlined"
        [size]="20"
      ></onyx-icon>

      {{ 'labels.translations' | translate }}
    </onyx-button>
  </onyx-form-group>

  @if (showTranslations()) {
    <div class="translations">
      <div class="heading">
        <div class="buttons">
          <onyx-button
            variant="outlined"
            [size]="32"
            [spinner]="loading()"
            (click)="!loading() ? suggestTranslations() : null"
          >
            {{ `${I18N}.suggestTranslations` | translate }}
          </onyx-button>

          <onyx-button
            variant="outlined"
            [size]="32"
            (click)="clearTranslations()"
          >
            {{ 'labels.clear' | translate }}
          </onyx-button>
        </div>

        <onyx-icon-button
          variant="outlined"
          color="black"
          [size]="32"
          icon="arrow-alt-up-outlined"
          (click)="toggleTranslations()"
        ></onyx-icon-button>
      </div>

      <div class="content">
        @for (language of languages(); track language) {
          <onyx-text-field
            [formControlName]="language"
            [label]="`${DictionaryCode.LANGUAGE}.${language}`"
          ></onyx-text-field>
        }
      </div>
    </div>
  }
</form>
